import {Box} from "@chakra-ui/react";
import React from "react";

function CustomCheckbox(props) {
    const { value, label, isChecked, onChange, colorScheme } = props
    return (
        <Box
            display="flex"
            ml='1'
            alignItems="center"
            cursor="pointer"
            color={isChecked ? colorScheme ? colorScheme : "red.400" : null}
            userSelect="none"
            onClick={() => onChange(!isChecked)}
        >
            <Box>{label}</Box>
        </Box>
    );
};

export default CustomCheckbox;